import React from 'react';
import { ChevronDown, ChevronUp, Shield } from 'lucide-react';

const ImmediateActions = ({ expanded, onToggle, formData, setFormData }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50"
        onClick={onToggle}
      >
        <div className="flex items-center gap-3">
          <Shield className="w-5 h-5 text-green-600" />
          <h2 className="text-lg font-semibold text-gray-900">Immediate Actions Taken</h2>
        </div>
        {expanded ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
      </div>
      {expanded && (
        <div className="p-4 pt-0 border-t border-gray-200">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Actions Taken Immediately Following Incident
            </label>
            <textarea
              value={formData?.immediateActions}
              onChange={(e) => setFormData(prev => ({ ...prev, immediateActions: e?.target?.value }))}
              rows={5}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Describe any immediate actions taken to secure the area, provide first aid, notify authorities, etc..."
            />
            <p className="mt-1 text-xs text-gray-500">
              Include first aid provided, area secured, equipment shut down, notifications made, etc.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImmediateActions;